export default [
  {
    typ: "selbstbeteiligung",
    titel: "Selbstbeteiligung je Schadenfall",
    produktLinien: ["001", "002", "003"],
    selectname: "selbstbeteiligung",
    selectoptionen: [
      { label: "Keine", value: 0 },
      { label: "250 €", value: 250 },
      { label: "500 €", value: 500 },
      { label: "1.000 €", value: 1000 },
      { label: "2.000 €", value: 2000 },
    ],
  },
  {
    typ: "schadenfreiheitsrabatt",
    titel: "Schadenfreiheitsrabatt (SFR)",
    produktLinien: ["001", "002", "003"],
    selectname: "sfr",
    selectoptionen: [
      { label: "Ja", value: 1 },
      { label: "Nein", value: 0 },
    ],
    infoItem: {
      name: "sfr",
      titel: "Schadenfreiheitsrabatt (SFR)",
      text: "Bei Aktivierung des Schadenfreiheitsrabatts (SFR) erfolgt die Berechnung für Ihren Beitrag in Abhängigkeit zur Anzahl der Schäden. Bleibt Ihr Vertrag schadenfrei, erhöht sich Ihre Schadenfreiheitsklasse und damit Ihr Rabatt. Regulieren wir einen Schaden für Sie, dann stufen wir Sie zur nächsten Hauptfälligkeit eine SFR-Klasse zurück.",
    },
  },
  {
    typ: "anzahlvorschaeden",
    titel: "Anzahl Vorschäden",
    produktLinien: ["001", "002", "003"],
    selectname: "anzahlvorschaeden",
    selectoptionen: [
      { label: "Bitte wählen", value: -1 },
      { label: "0", value: 0 },
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
      { label: "4", value: 4 },
      { label: "5 und mehr", value: 5 },
    ],
    infoItem: {
      name: "tariffNumberOfPredamages",
      titel: "Anzahl Vorschäden",
      text: "Anzahl der Vorschäden in den letzten 5 Jahren.",
    },
  },
];
